export function SkeletonCard() {
  return (
    <div className="flex items-center rounded border border-green-200 bg-white px-[18px] py-4">
      {/* Avatar placeholder */}
      <div className="me-4 h-10 w-10 shrink-0 animate-pulse rounded-full bg-green-100" />

      {/* Text placeholders */}
      <div className="flex-1">
        <div className="h-4 w-2/5 animate-pulse rounded bg-green-100" />
        <div className="mt-2 h-3 w-1/3 animate-pulse rounded bg-green-100" />
      </div>

      {/* Chevron placeholder */}
      <div className="h-4 w-4 shrink-0 animate-pulse rounded bg-green-100" />
    </div>
  );
}
